// extracted by mini-css-extract-plugin
export default {"resetButton":"ResetButton_resetButton__7q7U0"};